import FilterBlogs from "./FilterBlogs";
import SortBlogs from "./SortBlogs";


export default function Sidebar() {
	

	return (
		<aside>
			<div className="sidebar-items">
				<SortBlogs />
				<FilterBlogs />
			</div>
		</aside>
	);
}
